import { useQuery } from "@tanstack/react-query";
import { api } from "api";
import { isNotFoundError } from "utils";

export const useConfirmationQueries = (guid?: string) => {
  const {
    data: paymentContext,
    error: contextError,
    isError: isContextError,
    isFetching: isContextFetching,
  } = useQuery({
    queryKey: ["paymentContext", guid],
    queryFn: async () => {
      const result = await api.customers.getPaymentContext(guid!);
      return result.data;
    },
    enabled: !!guid,
    retry: (failureCount, error) => !isNotFoundError(error) && failureCount < 3,
  });

  const { data: customerConfirmation } = useQuery({
    queryKey: ["confirmation", guid],
    queryFn: async () => {
      const result = await api.customers.getCustomerConfirmation(guid!);
      return result.data;
    },
    enabled: !!guid,
  });

  const { data: examDetails } = useQuery({
    queryKey: ["examDetails", customerConfirmation?.examDateId],
    queryFn: async () => {
      const result = await api.exams.getExamDate(
        customerConfirmation!.examDateId
      );
      return result.data;
    },
    enabled: !!customerConfirmation?.examDateId,
  });

  return {
    paymentContext,
    examDetails,
    isContextNotFound: isNotFoundError(contextError),
    isContextError,
    isContextFetching,
  };
};
